import React from "react";
import RegionSelector from "./RegionSelector";
import LoadingIndicator from "./LoadingIndicator";
import SitesList from "./SitesList";

const MapSidebar = ({
  selectedRegion,
  regions,
  showRegionDropdown,
  onToggleDropdown,
  onSelectRegion,
  onResetMap,
  isLoadingBoundary,
  systems,
  selectedSystemIds,
  onSystemClick,
  onCheckboxChange,
  onFitToSelected,
}) => {
  return (
    <div className="w-80 transition-all duration-300 ease-in-out bg-white shadow-xl relative">
      <RegionSelector
        selectedRegion={selectedRegion}
        regions={regions}
        showDropdown={showRegionDropdown}
        onToggleDropdown={onToggleDropdown}
        onSelectRegion={onSelectRegion}
        onReset={onResetMap}
      />

      <LoadingIndicator
        isLoading={isLoadingBoundary}
        message={isLoadingBoundary}
      />

      <div
        className="space-y-2 m-2 overflow-y-auto"
        style={{ maxHeight: "calc(100vh - 200px)" }}
      >
        <SitesList
          systems={systems}
          selectedSystemIds={selectedSystemIds}
          onSystemClick={onSystemClick}
          onCheckboxChange={onCheckboxChange}
          onFitToSelected={onFitToSelected}
        />
      </div>
    </div>
  );
};

export default MapSidebar;
